export const incomingWebsocketMessageActionType = 'WEBSOCKET/NEW_MESSAGE'

export const notifyIncomingWebSocketMessage = (channel: any, data: any) => {
  return {
    type: incomingWebsocketMessageActionType,
    payload: {
      channel,
      data,
    },
  }
}
